import BaseGridLayoutDataTree from './BaseGridLayoutDataTree';
export default class GridLayoutDataTree extends BaseGridLayoutDataTree {}